// src/data/patchNotes.js
// Ordered newest-first. Add a new entry at the top whenever a real,
// user-visible update ships — the version string is the localStorage key
// PatchNotesModal compares against, so it must be unique and change every
// time there's something worth showing.
export const patchNotes = [
  {
    version: '2026-09-24',
    date: 'September 24, 2026',
    title: "What's new",
    items: [
      'Meet Elp, your new guide — he walks along the bottom of the home page as you scroll, and he has opinions',
      'Elpis has a new look: warmer colours, bolder headlines, smoother scrolling, and cards that respond as you move over them',
      'You can finally save opportunities — tap the bookmark on any card and it waits for you in Saved',
      'Press Cmd+K (Ctrl+K on Windows) to jump anywhere or find any opportunity by typing',
      'The navigation rail is now grouped by colour (Explore, Connect, AI, You), and on your phone there is a new tab bar at the bottom',
      'AI match analysis writes its reasoning out live, match scores count up, deadlines pulse when they are close, and the Money Meter rolls like a real counter',
      'New loading screens, empty states, and a 404 page that is genuinely dizzy',
      'Next patch: Elp picks your one task for today, breaks applications into checklists, and plans your week',
    ],
  },
  {
    version: '2026-09-23',
    date: 'September 23, 2026',
    title: "What's new",
    items: [
      'Elpis now lives at elpisbridge.com',
      'New opportunity: the Lester B. Pearson International Scholarship (University of Toronto, closes 6 November 2026)',
      'Deadlines refreshed for the Mandela Washington Fellowship (13 October 2026) and Mastercard Foundation Scholars (27 September 2026)',
    ],
  },
  {
    version: '2026-08-25',
    date: 'August 25, 2026',
    title: "What's new",
    items: [
      'A real navigation rail on the left — every section is one hover away, and you can pin it open',
      'Home is now a proper dashboard — your streak, Money Meter, urgent deadlines, and a recommended next opportunity, all in one place',
      'You can now mark an opportunity Applied, Accepted, or Completed — track your real status, not just what you\'ve saved',
      'Discover cards now show prize value and deadline urgency at a glance',
      'AI match analysis got a visual refresh so it\'s clearer when it\'s generating vs. showing results',
      'Money Meter now counts up, and streak milestones get a little more spectacle',
    ],
  },
  {
    version: '2026-08-24',
    date: 'August 24, 2026',
    title: "What's new",
    items: [
      'New About and FAQ pages — browse or search common questions',
      'Real AI match reasoning — see why an opportunity fits you, not just a score',
      'A proper home screen when you open the app, with quick links to everything',
      'Notifications — a bell up top now shows account updates and admin messages',
      'New: a short daily lesson + quiz at "Today\'s Lesson" — builds a streak the more consistently you show up',
      'Streak milestones now unlock real perks — bonus AI credits or a streak freeze, bigger rewards at 30/50/100 days',
      'Missed a day? A streak freeze or a recovery option can usually get it back — check Home if you lost one',
      'Fixed leftover old branding in a few places across the site',
    ],
  },
  {
    version: '2026-08-19',
    date: 'August 19, 2026',
    title: "What's new",
    items: [
      'Elpis is here: Launchpad rebuilt under a new name, with a light, warm look and a headline that assembles itself as you scroll',
      'Full account settings: change your username, email or password, pause your account, or delete it',
      'Mentor contact, the Teammates directory, an AI chat bubble and the full sign-up flow are live',
      'Real messages between accepted Teammates: text and images, with blocking and reporting built in',
      'AI match analysis is remembered for you, so reopening an opportunity is instant, and AI chat remembers the conversation',
      'Fixed a sign-in bug where closing the app in the middle of email verification could skip the verification step',
      'A proper 404 page for links that lead nowhere',
    ],
  },
];
